import { createIntl } from 'react-intl';
import zendesk from '@/zendesk';

let $translate = null;

let isReady = false;
let $timeout = null;
let version = 0;
let intl = null;
const reloadListeners = [];

const changeDoubleBracesToSingle = value => {
  if (!value) return value;
  if (value.indexOf('{') < 0 || value.indexOf('}') < 0) return value; // Check if there are braces, this is faster than doing the replace regex on all values.
  return value.replace(/\{\{\s*([^}]+)\s*\}\}/g, '{$1}');
};

const getLocale = () => ($translate ? $translate.use() : '');
const getTranslations = locale => ($translate ? $translate.getTranslationTable(locale) : []);

const initIntlObject = () => {
  const locale = getLocale();

  zendesk.setLocale(locale);

  const translations = getTranslations(locale);

  const messages = Object.keys(translations).reduce((o, key) => {
    if (key.indexOf(' ') >= 0) return o; // Translation keys in react can't use spaces, so we filter them out to save some memory.
    // eslint-disable-next-line no-param-reassign
    o[key] = changeDoubleBracesToSingle(translations[key]); // See comment above function
    return o;
  }, {});

  intl = createIntl({ locale, messages });
};

export const translate = message => {
  if (!intl) {
    console.warn('intl object is empty');
  }
  return intl.formatMessage(message);
};

export const initTranslateService = (angularTranslate, angularTimeout) => {
  $translate = angularTranslate;
  $timeout = angularTimeout;

  if ($translate) {
    if ($translate.isReady()) {
      isReady = true;
      version += 1;
      initIntlObject();
    } else {
      // Still loading translations, wait for it to finish and then init translations
      $translate.onReady(() => {
        isReady = true;
        version += 1;
        initIntlObject();
      });
    }
  } else {
    isReady = false;
  }
};

const reloadTranslations = lang => {
  if (!$timeout || !$translate) return;
  $timeout(() => {
    $translate.refresh(lang).then(() => {
      version += 1;
      reloadListeners.forEach(l => l(version));
    });
  }, 0);
};

export default {
  isReady,
  translate,
  getIntl: () => intl,
  getVersion: () => version,
  reload: reloadTranslations,
  onLocaleChanged: initIntlObject,
  onReload: listener => reloadListeners.push(listener),
  offReload: listener => {
    const idx = reloadListeners.indexOf(listener);
    if (idx >= 0) reloadListeners.splice(idx, 1);
  },
};
